module.exports = __webpack_public_path__ + "static/media/courseimg.01147b19.jpeg";